/**
 * @file Holds the <AdventuresPage> page
 * @since 0.1.0
 * @author Anton Komarenko <mi3ta@sent.as>
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { DETAIL_CON_FORM } from './FormFieldData';
import InputField from '../InputField';

import {
  actions as GuideSetFilterActions,
  selectors as GuideSetFilterSelectors,
} from '../../redux/modules/GuideFilter';
import { selectors as userSelectors } from '../../redux/modules/users';
import { actions as updateUserActions } from '../../redux/modules/UpdateUser';

import styles from 'styles/pages/NewGuidePage.module.scss';

/* Component definition */
class UserContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      businessAddress: '',
      website: '',
      youtubeChannel: '',
      errorName: '',
    };
  }

  componentDidMount() {
    const { phoneNumber, businessAddress, website, youtubeChannel } = this.props;
    this.setState({
      phoneNumber: phoneNumber,
      businessAddress: businessAddress,
      website: website,
      youtubeChannel: youtubeChannel,
    });
  }

  onInputTextChange = () => {};

  nextStep = () => {
    if (!this.validateForm()) {
      return;
    }

    const { nextStep, setGuideInfo, updateUserContact, loggedUser } = this.props;
    const { phoneNumber, businessAddress, website, youtubeChannel } = this.state;

    //Set Guides' information
    setGuideInfo({
      ['phoneNumber']: phoneNumber,
      ['businessAddress']: businessAddress,
      ['website']: website,
      ['youtubeChannel']: youtubeChannel,
    });

    if (loggedUser) updateUserContact();

    nextStep();
  };

  previewStep = () => {
    const { previewStep } = this.props;
    previewStep();
  };

  validateForm() {
    const { businessAddress } = this.state;

    if (businessAddress === '') {
      this.setState({ errorName: 'Location' });
      return false;
    }
    return true;
  }

  setFieldValue = (value, type) => {
    if (type === 'phone') this.setState({ phoneNumber: value });
    else if (type === 'Location') this.setState({ businessAddress: value });
    else if (type === 'youtube') this.setState({ youtubeChannel: value });
    else if (type === 'website') this.setState({ website: value });
  };

  render() {
    const { phoneNumber, businessAddress, website, youtubeChannel, errorName } = this.state;

    return (
      <div>
        <div>
          <h2>Detailed contacts</h2>
          <p>Let us know a bit more about you!</p>
        </div>
        <form className={styles.form}>
          <div>
            {DETAIL_CON_FORM.map((data, index) => {
              return (
                <div key={index}>
                  <InputField
                    wrapClass={styles.form_group}
                    label={data.label}
                    type={data.type}
                    holder={data.holder}
                    name={data.name}
                    labelClass={styles.label}
                    inputClass={styles.inputBorder}
                    inputErrorClass={styles.inputBorderError}
                    value={
                      data.name === 'phone'
                        ? phoneNumber
                        : data.name === 'Location'
                          ? businessAddress
                          : data.name === 'youtube'
                            ? youtubeChannel
                            : data.name === 'website'
                              ? website
                              : ''
                    }
                    setFieldValue={this.setFieldValue}
                    errorName={errorName}
                    errorText={styles.errorText}
                  />
                </div>
              );
            })}
          </div>

          <div className={styles.form_group}>
            <button type='button' className={styles.form_button} onClick={() => this.nextStep()}>
              Continue
            </button>
            <button type='button' className={styles.form_button} onClick={() => this.previewStep()}>
              Back
            </button>
          </div>
        </form>
      </div>
    );
  }
}

UserContact.propTypes = {
  nextStep: PropTypes.func.isRequired,
  previewStep: PropTypes.func.isRequired,
  setGuideInfo: PropTypes.func.isRequired,
  updateUserContact: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
  businessAddress: PropTypes.string,
  youtubeChannel: PropTypes.string,
  website: PropTypes.string,
  loggedUser: PropTypes.string,
};

const selectors = createStructuredSelector({
  phoneNumber: GuideSetFilterSelectors.phoneNumberSelector,
  businessAddress: GuideSetFilterSelectors.businessAddressSelector,
  youtubeChannel: GuideSetFilterSelectors.youtubeChannelSelector,
  website: GuideSetFilterSelectors.websiteSelector,
  loggedUser: userSelectors.userIdSelector,
});

const actions = {
  setGuideInfo: GuideSetFilterActions.setGuideFilter,
  updateUserContact: updateUserActions.updateUserContact,
};

export default connect(
  selectors,
  actions
)(UserContact);
